import { Grid } from '@mui/material';
import Typography from '@mui/material/Typography';
import Button from 'common/Button';
import FormInputLabel from 'common/FormInputLabel';
import FormSelectInput from 'common/FormSelectInput';
import FormTextInput from 'common/FormTextInput';
import React, { useState } from 'react';

const OutOfOfficeFormData = ({ formData, setFormData, providers, onAddProvider, businessData }) => {
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    };
    
    const [openProviderDropdown, setOpenProviderDropdown] = useState(false);

    // Create options list with business + providers
    const listOfOptions = [
        {
            id: 'business',
            first_name: businessData?.name || 'Business',
            last_name: '',
        },
        ...(providers || [])
    ];

    return (
        <Grid container spacing={2}>
            {listOfOptions.length > 0 ? (
                <FormSelectInput
                    formData={formData}
                    label="Provider or Business"
                    name="provider"
                    handleChange={handleChange}
                    placeholder="Select a Provider or Business"
                    required={true}
                    openDropdown={openProviderDropdown}
                    setOpenDropdown={setOpenProviderDropdown}
                    renderValue={(selected) => {
                        if (!selected) {
                            return (
                                <Typography
                                    color="textSecondary"
                                    style={{
                                        fontStyle: 'italic',
                                    }}
                                >
                                    Select a Provider or Business
                                </Typography>
                            );
                        }

                        if (selected === 'business') {
                            return businessData?.name || 'Business';
                        }

                        const val = providers.find((d) => d.id === selected);
                        return val ? val.first_name + ' ' + val.last_name : '';
                    }}
                    options={listOfOptions}
                    optionKey={'id'}
                    optionValue={['first_name', 'last_name']}
                    value={formData.provider}
                    inputSize={12}
                    labelSize={12}
                />
            ) : (
                <Grid item xs={12}>
                    <FormInputLabel label="Provider or Business" required={true} />
                    <Button
                        onClick={onAddProvider}
                        className="w-full justify-start"
                        style={{
                            height: '42px',
                            backgroundColor: '#F5F1ED',
                            border: '1px solid #CBC1B7',
                            borderRadius: '8px',
                            color: '#57534E',
                            fontSize: '14px',
                            fontWeight: '400',
                            textTransform: 'none',
                            justifyContent: 'flex-start',
                            paddingLeft: '20px'
                        }}
                    >
                        + Add a Provider
                    </Button>
                </Grid>
            )}

            <FormTextInput
                label="Start Date"
                name="start_date"
                value={formData.start_date}
                handleChange={handleChange}
                placeholder=""
                type="date"
                required={true}
                labelSize={12}
                textSize={6}
                startDate={new Date()}
                disableFiltering={true}
                invoice={false}
                formData={formData}
            />

            <FormTextInput
                label="Start Time"
                name="start_time"
                value={formData.start_time}
                handleChange={handleChange}
                placeholder=""
                type={'time'}
                required={true}
                labelSize={12}
                noLabel={true}
                textSize={6}
                disableFiltering={true}
                invoice={false}
                formData={formData}
            />

            <FormTextInput
                label="End Date"
                name="end_date"
                value={formData.end_date}
                handleChange={handleChange}
                placeholder=""
                type={'date'}
                required={true}
                labelSize={12}
                textSize={6}
                startDate={new Date(formData?.start_date)}
                disableFiltering={true}
                invoice={false}
                formData={formData}
            />

            <FormTextInput
                label="End Time"
                name="end_time"
                value={formData.end_time}
                handleChange={handleChange}
                placeholder=""
                type={'time'}
                required={true}
                labelSize={12}
                noLabel={true}
                textSize={6}
                disableFiltering={true}
                invoice={false}
                formData={formData}
            />
        </Grid>
    );
};

export default OutOfOfficeFormData;
